export default __webpack_public_path__ + "device_stick_up_cam_battery.7f49ba1b.png";